// Shared brand utility functions for consistent styling across the app

export const getBrandColor = (brandName) => {
  // Brand-specific color mapping
  const brandColors = {
    'APPLE': '#A2AAAD',        // Apple's Space Gray
    'ANDROID': '#3DDC84',      // Android Green
    'SAMSUNG': '#1428A0',      // Samsung Blue
    'REALME': '#FFD700',       // Realme Gold/Yellow
    'INFINIX': '#FF6B35',      // Infinix Orange
    'XIAOMI': '#FF6900',       // Xiaomi Orange
    'HUAWEI': '#FF0000',       // Huawei Red
    'VIVO': '#4285F4',         // Vivo Blue
    'OPPO': '#00A651',         // Oppo Green
  };

  // Normalize brand name to uppercase for matching
  const normalizedBrand = brandName?.toUpperCase().trim();

  // Return specific brand color if available
  if (normalizedBrand && brandColors[normalizedBrand]) {
    return brandColors[normalizedBrand];
  }

  // Fallback to original color generation for other brands
  const fallbackColors = ['#FF6B35', '#F7931E', '#FFD23F', '#06FFA5', '#118AB2', '#E74C3C'];
  const index = brandName ? brandName.length % fallbackColors.length : 0;
  return fallbackColors[index];
};

export const getBrandLogo = (brandName) => {
  // Normalize brand name to uppercase for matching
  const normalizedBrand = brandName?.toUpperCase().trim();

  // Brand logo mapping using emoji and symbols for universal support
  const brandLogos = {
    'APPLE': '🍎',           // Apple emoji
    'ANDROID': '🤖',         // Android robot emoji
    'SAMSUNG': 'S',          // Samsung S symbol
    'REALME': 'R',           // Realme R
    'INFINIX': '∞',          // Infinity symbol for Infinix
    'XIAOMI': 'Mi',          // Xiaomi Mi
    'HUAWEI': 'H',           // Huawei H
    'VIVO': 'V',             // Vivo V
    'OPPO': 'O',             // Oppo O
  };

  if (normalizedBrand && brandLogos[normalizedBrand]) {
    return brandLogos[normalizedBrand];
  }

  // Fallback to brand initials
  return brandName?.substring(0, 2).toUpperCase() || 'PR';
};

// Helper function to determine if text should be white based on background color
export const shouldUseWhiteText = (backgroundColor) => {
  // Remove # if present and convert to RGB
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate luminance using relative luminance formula
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return true for white text if background is dark (luminance < 0.5)
  return luminance < 0.5;
};

// Get text color for brand avatars and chips
export const getBrandTextColor = (brandName) => {
  // Return white text for ALL brands for consistent styling
  return '#FFFFFF';
};